import { Link } from "react-router-dom";
import { MapPin, ShoppingBag, CreditCard, QrCode } from "lucide-react";

const HOW_STEPS = [
    {
        icon: <MapPin size={20} />,
        title: "Find a machine",
        body: "Landing at airports, coffee shops, doctor's offices — everywhere life makes you wait.",
    },
    {
        icon: <ShoppingBag size={20} />,
        title: "Pick your bag",
        body: "No mystery unless you want it — every bag shows exactly what's inside. Scout the lineup in the app or right here first.",
    },
    {
        icon: <CreditCard size={20} />,
        title: "Pay at the machine",
        body: "Tap or swipe. Card, Apple Pay, Google Pay. Ten seconds, tops.",
    },
    {
        icon: <QrCode size={20} />,
        title: "Scan & join",
        body: "That QR code on your bag? It's your invitation to the whole BookBlend community.",
    },
];

const StepCard = ({ step, index }) => (
    <div
        data-testid={`how-step-${index}`}
        className="relative rounded-[2rem] bg-white border border-[#E5D7C5] p-8 shadow-soft hover:shadow-lift hover:-translate-y-0.5 transition-all duration-300"
    >
        <span className="absolute top-6 right-7 font-serif text-5xl text-[#C4956A]/20">
            {index + 1}
        </span>
        <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-[#C4956A] text-white">
            {step.icon}
        </span>
        <h3 className="font-serif text-2xl mt-5 leading-tight text-[#2D2D2D]">
            {step.title}
        </h3>
        <p className="mt-3 text-[15px] text-[#6B655C] leading-relaxed">
            {step.body}
        </p>
    </div>
);

export const HowItWorks = () => (
    <section
        id="how-it-works"
        data-testid="how-it-works-section"
        className="py-24 md:py-32 bg-[#F5E9D7]/60 border-b border-[#E5D7C5]"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
            <div className="max-w-2xl mb-16">
                <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C4956A]">
                    How it works
                </span>
                <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-3 text-[#2D2D2D]">
                    No carts. No shipping. No waiting by the mailbox.{" "}
                    <span className="italic">Just grab a bag and go</span>.
                </h2>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {HOW_STEPS.map((step, i) => (
                    <StepCard key={step.title} step={step} index={i} />
                ))}
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-4">
                <Link
                    to="/shop"
                    data-testid="how-it-works-bags-cta"
                    className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#2D2D2D] text-[#FDF6EE] font-medium hover:bg-[#C4956A] transition-colors"
                >
                    <ShoppingBag size={16} /> See the Bag Drop
                </Link>
                <Link
                    to="/find-a-machine"
                    data-testid="how-it-works-machine-cta"
                    className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white border border-[#E5D7C5] text-[#2D2D2D] font-medium hover:border-[#C4956A] hover:text-[#C4956A] transition-colors"
                >
                    <MapPin size={16} /> Want a machine near you?
                </Link>
                <p className="text-sm text-[#6B655C]">
                    Bags from $34.99 — every one hides a curated book and a
                    reading journal.
                </p>
            </div>
        </div>
    </section>
);
